import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card } from './ui/card';
import { Building2, Users, Briefcase, TrendingUp } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SuperAdminHome = ({ getAuthHeaders }) => {
  const [stats, setStats] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API}/admin/stats`, getAuthHeaders());
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <div className="animate-pulse">Loading...</div>;
  }

  const statCards = [
    { label: 'Total Companies', value: stats?.total_companies || 0, icon: Building2, color: 'from-blue-500 to-blue-600', testId: 'total-companies' },
    { label: 'Active Companies', value: stats?.active_companies || 0, icon: TrendingUp, color: 'from-green-500 to-green-600', testId: 'active-companies' },
    { label: 'Total Users', value: stats?.total_users || 0, icon: Users, color: 'from-purple-500 to-purple-600', testId: 'total-users' },
    { label: 'Jobs Today', value: stats?.total_jobs_today || 0, icon: Briefcase, color: 'from-orange-500 to-orange-600', testId: 'jobs-today' },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>Dashboard Overview</h2>
        <p className="text-gray-500">System-wide statistics and insights</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {statCards.map((stat, index) => (
          <Card key={index} className="p-6 hover:shadow-lg transition-shadow">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">{stat.label}</p>
                <p className="text-3xl font-bold" data-testid={stat.testId}>{stat.value}</p>
              </div>
              <div className={`p-3 rounded-xl bg-gradient-to-br ${stat.color}`}>
                <stat.icon className="w-6 h-6 text-white" />
              </div>
            </div>
          </Card>
        ))}
      </div>

      <Card className="p-6">
        <h3 className="text-xl font-bold mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>Quick Actions</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <button className="p-4 border-2 border-dashed border-gray-300 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors">
            <Building2 className="w-8 h-8 text-blue-600 mx-auto mb-2" />
            <p className="text-sm font-medium">Create Company</p>
          </button>
          <button className="p-4 border-2 border-dashed border-gray-300 rounded-lg hover:border-purple-500 hover:bg-purple-50 transition-colors">
            <Users className="w-8 h-8 text-purple-600 mx-auto mb-2" />
            <p className="text-sm font-medium">Add User</p>
          </button>
          <button className="p-4 border-2 border-dashed border-gray-300 rounded-lg hover:border-green-500 hover:bg-green-50 transition-colors">
            <TrendingUp className="w-8 h-8 text-green-600 mx-auto mb-2" />
            <p className="text-sm font-medium">View Reports</p>
          </button>
        </div>
      </Card>
    </div>
  );
};

export default SuperAdminHome;
